webpackJsonp([234148947999315],{

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Download API Server'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\u2019ll clone and run the API server that we\'ll need for the rest of this Quickstart.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Clone the Server'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The server we\'ll need is in a repository on GitHub under ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore-tutorial-api' },
	        'lore/lore-tutorial-api'
	      ),
	      '. Run this command to clone the server into your local environment:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { title: 'SSH', active: true, text: '\n        $ git clone git@github.com:lore/lore-tutorial-api.git\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { title: 'HTTPS', text: '\n        $ git clone https://github.com/lore/lore-tutorial-api.git\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Install Dependencies'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the server is cloned, navigate into the directory and install the dependencies:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      $ cd lore-tutorial-api\n      $ npm install\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Stop the Mock API Server'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the dependencies are installed, ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'stop the mock server'
	      ),
	      ' (Ctrl+C). We\'ll need the port it\'s currently running on (1337) to be free so that the Sails server can bind to it.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Start the Real API Server'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the mock server is stopped, and port 1337 is free again, start the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-tutorial-api'
	      ),
	      ' server using ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm start'
	      ),
	      '. A successful startup will produce console output similar to this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      $ npm start\n\n      info:\n      info:                .-..-.\n      info:\n      info:    Sails              <|    .-..-.\n      info:    v0.12.14            |\\\n      info:                       /|.\\\n      info:                      / || \\\n      info:                    ,\'  |\'  \\\n      info:                 .-\'.-==|/_--\'\n      info:                 `--\'-------\'\n      info:    __---___--___---___--___---___--___\n      info:  ____---___--___---___--___---___--___-__\n      info:\n      info: Server lifted in `/Users/jchansen/lore/lore-tutorial-api`\n      info: To see your app, visit http://localhost:1337\n      info: To shut down Sails, press CTRL + C at any time.\n\n        debug: -------------------------------------------------------\n        debug: :: Sun Mar 25 2018 21:21:26 GMT-0700 (MST)\n\n        debug: Environment : development\n        debug: Port        : 1337\n        debug: -------------------------------------------------------\n\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you now navigate to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337'
	      ),
	      ' you will see a webpage showing the API routes:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        tweets: "http://localhost:1337/tweets",\n        users: "http://localhost:1337/users",\n        user: "http://localhost:1337/user"\n      }\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At this point our application no longer works - this is epected. If you refresh your browser, you should see this error in the console:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      Expected models to be an array but got [Object {data: Array[5], meta: Object}].\n      Did you forget to override parse to extract the models?\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We\'ll resolve that issue in the next step and restore our application\'s functionality.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'update our application to work with the new API'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-server-step-1-js-3eb46c4226ae7d75ccdf.js